function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M122.226 47.15 81.116 6.023q-3.195 3.14-4.768 6.935-1.566 3.796-1.568 7.764c0 2.608.521 5.176 1.58 7.706L50.7 54.067a30.1 30.1 0 0 0-13.83-3.373q-5.665.001-10.962 2.053c-3.532 1.372-6.685 3.432-9.46 6.193l21.866 21.807s9.407 9.316 9.264 9.267l21.73 21.788q4.16-4.16 6.202-9.46A30.2 30.2 0 0 0 77.55 91.4a30 30 0 0 0-.836-7.108 29.7 29.7 0 0 0-2.53-6.742L99.82 51.91q3.796 1.562 7.705 1.56 3.989.001 7.774-1.57c2.523-1.042 4.832-2.63 6.926-4.747z",
    style: {
      fill: "#f19c00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.483 80.617 24.522 96.674l-10.53 12.769-6.671 8.862c-1.548 2.286-2.336 3.806-2.336 4.527l-.048.288.138.048v.233l.095-.137.233.048c.727 0 2.241-.769 4.527-2.288l8.862-6.623 12.77-10.577 16.153-13.96-9.243-9.244z",
    style: {
      fill: "#f19c00"
    }
  }));
};
export default SvgIcon;